import { createElementBlock as o, openBlock as l, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 42 52"
};
function r(d, e) {
  return l(), o("svg", n, [...e[0] || (e[0] = [
    t("path", {
      fill: "#CCC",
      "fill-rule": "evenodd",
      d: "M18.255 40.129V51.13s11.083-9.06 18.907-19.414c2.768-3.663 4.648-9.432 3.912-14.238C39.472 7.017 30.869-.219 20.21.005 9.05.239 0 8.987 0 20.067 0 37.54 18.255 40.129 18.255 40.129m2.363-9.767c5.693 0 10.308-4.539 10.308-10.138 0-5.598-4.615-10.137-10.308-10.137-5.694 0-10.309 4.539-10.309 10.137s4.615 10.138 10.309 10.138",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const s = { render: r };
export {
  s as default,
  r as render
};
